// Ad provider adapter. Everything vendor-specific lives behind this interface
// so the network can be swapped (or faked in tests) without touching the gate,
// the modal, or the placements.

/** 'blocked' = script killed with the network up (adblock signal). */
export type LoadResult = 'ok' | 'blocked' | 'timeout'
export type FillResult = 'filled' | 'unfilled' | 'blocked'

export interface AdProvider {
  id: string
  /** Load the vendor SDK once (idempotent; failed loads may be retried). */
  loadSdk(): Promise<LoadResult>
  /**
   * Render one ad unit into `host`. Resolves once filled, unfilled, or blocked.
   * `size` pins the creative: fixed WxH, or fixed-height full-width (width 0).
   * The host must never clip the rendered ad (placement policy) — sizes here
   * and the host's reserved space must agree.
   */
  renderUnit(host: HTMLElement, slot: string, size: { width: number; height: number }): Promise<FillResult>
  /** Vendor-independent adblock probe (bait element). */
  detectAdblock(): Promise<boolean>
}

let testProvider: AdProvider | null = null

/** Test hook: swap in a scripted provider (null restores the real one). */
export function _setTestProvider(p: AdProvider | null): void {
  testProvider = p
}

export function _getTestProvider(): AdProvider | null {
  return testProvider
}
